export default function freezeObjectKeys(obj){
  return Object.entries(obj).reduce((acc, e) => {
    const v = e[1];
    acc[e[0]] = typeof v === 'object' ? Object.freeze(v) : v;
    return acc;
  }, {});
}
